export const issueCard = async (
    API_URL: string,
    employerId: string,
    token: string,
    employeeId: string,
    offeringId: string
) => {
    const response = await fetch(
        `${API_URL}/employers/${employerId}/cards?employeeId=${employeeId}&offeringId=${offeringId}`,
        {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({})
        }
    );

    if (!response.ok) {
        throw new Error("There was a problem issuing the cards");
    }        

}